import PropTypes from 'prop-types';

export const JobCustomPanelBlockPropTypes = {
  customPanel: PropTypes.object.isRequired,
  setCustomPanelResults: PropTypes.func.isRequired,
  customPanelResults: PropTypes.arrayOf(PropTypes.object),
  job: PropTypes.object,
};

export const JobCustomPanelBlockDefaultProps = {
  customPanelResults: []
};
